import React, {Component} from 'react'
import  './ComingSoon.css';
import {ShapeFive} from '../Shapes/Shapes';

class ComingSoon extends Component {

  render(){
    return <div className="jo-coming-soon">
      <ShapeFive/>
      <div className="jo-coming-soon-text">
        <h1>Under Construction</h1>
        <h3>New site coming soon</h3>
      </div>
    </div>
  }

}

export default ComingSoon
